<script setup lang="ts">
    import { computed } from 'vue';
    import { vatBreakdown } from './SmsTopUp.helpers';

    // What the top-up costs, in minor units: the amount excl. VAT, the VAT with its rate, and the total — for the card step the
    // payment intent's amount (what is charged), for the invoice Chargebee's estimate. Each figure on its own line, so a label
    // not yet imported into SimpleLocalize leaves the amounts readable.
    const props = defineProps<{ net: number; total: number; currencyCode: string }>();

    const breakdown = computed(() => vatBreakdown(props.net, props.total));
</script>

<template>
    <table class="table m-md-b">
        <tbody>
            <tr>
                <td>{{ $Resources.SmsTopUpNetLabel }}</td>
                <td class="text-right">{{ breakdown.net }} {{ props.currencyCode }}</td>
            </tr>
            <tr>
                <td>{{ ($Resources.SmsTopUpVatLabel ?? '').replace('{0}', breakdown.rate) }}</td>
                <td class="text-right">{{ breakdown.vat }} {{ props.currencyCode }}</td>
            </tr>
            <tr class="fw-600">
                <td>{{ $Resources.SmsTopUpTotalLabel }}</td>
                <td class="text-right">{{ breakdown.total }} {{ props.currencyCode }}</td>
            </tr>
        </tbody>
    </table>
</template>
